import {createBrowserRouter, redirect, type LoaderFunction} from 'react-router';

import {Layout} from '@/modules/common/components/Layout';
import {queryClient} from '@/queryClient';
import {Component as RootComponent, loader as rootLoader} from '@/routes/Root';

const redirectToHomepage: LoaderFunction = async () => {
  if (import.meta.env.MODE === 'production') {
    return redirect(import.meta.env.VITE_HOMEPAGE_URL);
  }
  return redirect('/hotels?destinationId=destination-es-mallorca&rooms=A,A,10');
};

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <RootComponent />,
      loader: rootLoader(queryClient),
      children: [
        {
          index: true,
          loader: redirectToHomepage,
          element: null,
        },
        {
          element: <Layout />,
          children: [
            {
              path: 'hotels',
              lazy: () => import('@/routes/Hotels'),
            },
            {
              path: 'hotel/:hotelId/offers',
              lazy: () => import('@/routes/Offers'),
            },
          ],
        },
      ],
    },
    {
      path: '*',
      loader: redirectToHomepage,
      element: null,
    },
  ],
  {
    basename: import.meta.env.BASE_URL,
  }
);
